export default function AboutSection() {
  return (
    <section id="about" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-2">
            关于汗汗漫画
          </h2>
          <p className="text-sm text-foreground-500 mb-8">漫画全集免费漫画大全 · 海量资源免费看</p>
          <div className="bg-background-100 rounded-2xl p-8 md:p-10">
            <div className="w-16 h-16 mx-auto mb-6 flex items-center justify-center bg-primary-100 rounded-2xl">
              <i className="ri-book-read-line text-primary-600 text-2xl"></i>
            </div>
            <p className="text-base md:text-lg text-foreground-700 leading-relaxed">
              汗汗漫画是一个专注于<strong className="text-foreground-900">漫画全集免费阅读</strong>的在线平台，
              致力于为漫迷提供最全面、最优质的<strong className="text-foreground-900">免费漫画大全</strong>资源。
              平台汇聚了热血战斗、玄幻修真、恋爱甜宠、悬疑推理等全品类漫画，
              支持<strong className="text-foreground-900">全集免费阅读</strong>，无需注册登录即可畅享数万部精品漫画。
              每日同步更新数百话热门内容，让你<strong className="text-foreground-900">在线看漫画</strong>再也不用为找资源发愁，
              海量免费内容随时追更，一次看过瘾！
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}